// Reports Template Compare Widget
// This widget can be used to compare two values and display a percentage change
// Example: Log Usage / Log Usage Limit --- % Change in Log Usage from the previous month to now

import { Box, Chip, Typography } from '@mui/material';
import { isString } from 'lodash';
import type { FC } from 'react';

import type CompareWidgetProps from './ReportsTemplateCompareWidget.types';

const ReportsTemplateCompareWidget: FC<CompareWidgetProps> = ({
  title,
  value,
  maxValue,
  percentChange
}) => {
  const isPositive = percentChange !== undefined && percentChange > 0;
  const testId = title.split(' ').join('-').toLowerCase();
  return (
    <Box
      data-testid={`${testId}`}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
        justifyContent: 'space-between',
        height: '100%'
      }}
    >
      {/* Title */}
      <Typography
        variant="h6"
        sx={{
          color: '#1C4A50',
          fontWeight: 600,
          fontSize: 15
        }}
      >
        {title}
      </Typography>

      {/* Value + Max + Percent */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'flex-end',
          justifyContent: 'space-between'
        }}
      >
        {/* Main Value and Max */}
        {isString(value) ? (
          <Typography variant="h3" sx={{ fontWeight: 600 }}>
            <span
              style={{
                color:
                  Number(maxValue) && Number(value) > Number(maxValue)
                    ? '#C62828'
                    : ''
              }}
            >
              {value}
            </span>
            {maxValue !== undefined && (
              <Typography
                component="span"
                variant="h6"
                sx={{
                  color: 'text.secondary',
                  fontWeight: 400,
                  marginLeft: 0.6,
                  position: 'relative',
                  top: '2px'
                }}
              >
                / {maxValue}
              </Typography>
            )}
          </Typography>
        ) : (
          <Box>{value}</Box>
        )}
        {/* Percent Change */}
        {percentChange !== undefined && (
          <Chip
            label={`${percentChange > 0 ? '+' : ''}${percentChange.toFixed(2)}%`}
            size="small"
            sx={{
              backgroundColor: !isPositive ? '#e1e1e1' : '#EEE3E1',
              color: !isPositive ? '#2E7D32' : '#C62828',
              fontWeight: 600,
              borderRadius: 1
            }}
          />
        )}
      </Box>
    </Box>
  );
};

export default ReportsTemplateCompareWidget;
